import Vue from 'vue'
import VueRouter from 'vue-router'
import data from '../views/data.vue'
import login from '../views/login.vue'

Vue.use(VueRouter)

const routes = [
	{
	  path: '/',
	  name: 'login',
	  component: () => import('../views/login.vue')
	},
	
  {
    path: '/map',
    name: 'data',
    component: () => import('../views/data.vue')
  },
	{
	  path: '/test',
	  name: 'testData',
	  component: () => import('../views/testData.vue')
	},
  
]

const router = new VueRouter({
  routes
})

export default router
